import {
  FileTrigger as FileTriggerRAC,
  FileTriggerProps,
} from "react-aria-components";

export default function FileTrigger({
  label,
  ...props
}: FileTriggerProps & { label?: string | React.ReactNode }) {
  if (label) {
    return (
      <label>
        <span className="hidden">{label}</span>
        <FileTriggerRAC {...props} />
      </label>
    );
  }
  return <FileTriggerRAC {...props} />;
}
